// Eigenschappen van een product voor het filter "Eigenschappen" (MOW-EIGENSCHAPPEN-NOV26): een korte, bewust gekozen
// lijst in plaats van alle ±300 tags van de producten. Een eigenschap is een naam voor een of meer tags (en bij de
// voordeelverpakking ook het veld pack). De lijst aanpassen = dit bestand aanpassen; de tags in de producten blijven zoals ze zijn.
//
// Bewust zonder imports (zoals lib/filter-query.ts), zodat Node dit bestand rechtstreeks laadt voor de test.
// Gekozen op 2-11-2026 uit de tags van de 271 actieve producten (aantallen tussen haakjes, met de samengevoegde tags):
//   stretch (63)  naadloos (45)  warm (36)  vormvast (29)  lange mouw (22)  voordeelverpakking (56)

export interface PropertyDef {
  /** Sleutel in het adres (?eigenschap=lange-mouw): kleine letters, cijfers en streepjes. */
  key: string;
  /** Wat de bezoeker ziet. */
  label: string;
  /** Tags (genormaliseerd: kleine letters, spaties als streepje) die bij de eigenschap horen. */
  tags: string[];
  /** Optioneel: het veld pack ("3-pack", "Multipack") hoort er ook bij. */
  fromPack?: (pack: string) => boolean;
}

/** "2-pack", "3 pack", "12-pack" (vanaf 2 stuks) of "Multipack"; "Single", "Set", "1 paar" en "1-pack" niet. */
export function isMultipack(pack: unknown): boolean {
  const s = typeof pack === "string" ? pack.trim() : "";
  const m = /^(\d+)\s*-?\s*pack$/i.exec(s);
  return (!!m && Number(m[1]) >= 2) || /^multipack$/i.test(s);
}

export const PRODUCT_PROPERTIES: PropertyDef[] = [
  { key: "stretch", label: "Stretch", tags: ["stretch", "elastisch"] },
  { key: "naadloos", label: "Naadloos", tags: ["naadloos", "zonder-zijnaden"] },
  { key: "warm", label: "Warm", tags: ["warm", "koude-dagen", "thermo-ondergoed", "winterslaap"] },
  { key: "vormvast", label: "Vormvast", tags: ["vormvast"] },
  { key: "lange-mouw", label: "Lange mouw", tags: ["lange-mouw"] },
  { key: "voordeelverpakking", label: "Voordeelverpakking", tags: ["voordeelverpakking", "multipack"], fromPack: isMultipack },
];

const normTag = (t: unknown): string => String(t ?? "").trim().toLowerCase().replace(/\s+/g, "-");

/** De sleutels van de eigenschappen van dit product, in de volgorde van PRODUCT_PROPERTIES. Gooit nooit. */
export function productProperties(p: { tags?: ReadonlyArray<unknown> | null; pack?: unknown } | null | undefined): string[] {
  if (!p) return [];
  const tags = new Set((Array.isArray(p.tags) ? p.tags : []).map(normTag));
  return PRODUCT_PROPERTIES.filter((d) => d.tags.some((t) => tags.has(t)) || (d.fromPack ? d.fromPack(p.pack as string) : false)).map((d) => d.key);
}

/** De naam voor een sleutel; een onbekende sleutel (uit een oude link) blijft zoals hij is. */
export function propertyLabel(key: string): string {
  return PRODUCT_PROPERTIES.find((d) => d.key === key)?.label ?? key;
}
